import { render, staticRenderFns } from "./BottomofPage.vue?vue&type=template&id=4151c281"
import script from "./BottomofPage.vue?vue&type=script&lang=js"
export * from "./BottomofPage.vue?vue&type=script&lang=js"
import style0 from "./BottomofPage.vue?vue&type=style&index=0&id=4151c281&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports